<script>
export default {
  name: 'FilterableSelect',
  /** v-model */
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    /** Значение (обычно идентификатор) */
    value: {
      // eslint-disable-next-line no-bitwise
      type: Number | String,
      default: '',
    },
    /** Правила валидации */
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    /** Подпись для поля */
    label: {
      type: String,
      default: 'Дата',
    },
    /** Поле, в котором лежит отображаемое в выпадающем списке значение */
    itemText: {
      type: String,
      default: 'name',
    },
    /** Поле для значения */
    itemValue: {
      type: String,
      default: 'id',
    },
    /** Текст в случае отсуствия списка данных для выбора */
    noDataText: {
      type: String,
      default: 'Нет данных',
    },
    /** Функция для загрузки выпадающего списка */
    loadItemsFunction: {
      type: Function,
      required: true,
    },
    /** Загружать ли список при изменении значения в инпуте */
    loadOnChange: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      /** v-model для автокомплита */
      item: null,
      /** Данные, отображаемые в выпадающем списке */
      items: [],
      /** Процесс загрузки данных */
      isLoading: false,
      /** Триггер для фильтра выпадающего списка */
      searchItem: null,
      load: false,
    };
  },
  watch: {
    searchItem(newValue) {
      if (this.loadOnChange) {
        this.loadItems(newValue);
      }
    },
    value(newValue) {
      if (!this.load && typeof newValue === 'object') {
        this.load = true;
        this.item = newValue;
        const find = this.itemText;
        const itemArr = this.items.filter(item => item[find] === newValue[find]);
        if (itemArr.length < 1) {
          this.loadItems(newValue[find]);
        }
      }
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    /**
     * Загрузить данные для выпадающего списка
     * @param value значение, введённое пользователем
     */
    loadItems(value = '') {
      this.loadItemsFunction(value).then((items) => {
        this.items = items;
      });
    },
    /** Действия по выбору значения в компоненте */
    onChange(item) {
      let resultValue = null;
      if (!item) {
        resultValue = null;
      } else {
        resultValue = item[this.itemValue];
      }
      this.$emit('update:value', resultValue);
    },
  },
};
</script>

<template>
  <v-autocomplete
    v-model="item"
    :item-text="itemText"
    :item-value="itemValue"
    :items="items"
    :label="label"
    :loading="isLoading"
    :no-data-text="noDataText"
    :rules="rules"
    :search-input.sync="searchItem"
    class="plcolor"
    clearable
    return-object
    @change="onChange"
  ></v-autocomplete>
</template>

<style lang="scss" scoped></style>
